/* eslint-disable react/jsx-props-no-spreading */
import classNames from "lib/classNames";
import {
  ButtonHTMLAttributes,
  HTMLAttributes,
  PropsWithChildren,
  forwardRef,
} from "react";
import {
  SelectOptionsThemeProps,
  selectOptionsTheme,
  SelectButtonThemeProps,
  selectButtonTheme,
  SelectOptionThemeProps,
  selectOptionTheme,
} from "hardcover-ui/theme/components/select";
import { Listbox } from "@headlessui/react";
import Icon from "hardcover-ui/components/Icon";
import ChevronDown from "icons/solid/chevron-down.svg";
type ButtonProps = {
  size?: SelectButtonThemeProps["size"];
  open?: boolean;
  variant?: SelectButtonThemeProps["variant"];
} & Partial<ButtonHTMLAttributes<HTMLButtonElement>>;
export const Button = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<ButtonProps>
>(
  (
    {
      size = "md",
      variant = "normal",
      open = false,
      children,
      className,
      ...rest
    },
    ref
  ) => {
    const finalClassName = classNames(
      open
        ? selectButtonTheme.variant[`${variant}Open`]
        : selectButtonTheme.variant[variant],
      selectButtonTheme.size[size],
      className
    );

    const props = {
      ref,
      className: finalClassName,
      ...rest,
    };

    return (
      <Listbox.Button {...props}>
        <span>{children}</span>
        <Icon
          icon={ChevronDown}
          size="sm"
          className="text-tertiary"
          aria-hidden="true"
        />
      </Listbox.Button>
    );
  }
);

type OptionsProps = {
  className?: string;
  size?: SelectOptionsThemeProps["size"];
  variant?: SelectOptionsThemeProps["variant"];
} & Partial<HTMLAttributes<HTMLUListElement>>;
export const Options = forwardRef<
  HTMLUListElement,
  PropsWithChildren<OptionsProps>
>(({ children, variant = "normal", size = "md", className }, ref) => {
  const finalClassName = classNames(
    selectOptionsTheme.size[size],
    selectOptionsTheme.variant[variant],
    className
  );

  return (
    <Listbox.Options className={finalClassName} ref={ref}>
      {children}
    </Listbox.Options>
  );
});

type OptionProps = {
  className?: string;
  value: any;
  size?: SelectOptionThemeProps["size"];
  variant?: SelectOptionThemeProps["variant"];
} & Partial<HTMLAttributes<HTMLLIElement>>;
export const Option = forwardRef<HTMLLIElement, PropsWithChildren<OptionProps>>(
  ({ children, className, value, size = "md", variant = "normal" }, ref) => {
    const finalClassName = classNames(selectOptionTheme.size[size], className);

    return (
      <Listbox.Option
        ref={ref}
        key="no-edition"
        value={value}
        className={({ active }) =>
          classNames(
            finalClassName,
            selectOptionTheme.variant[`${variant}${active ? "Active" : ""}`]
          )
        }
      >
        {children}
      </Listbox.Option>
    );
  }
);

export default {
  Button,
  Options,
  Option,
};
